import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

export type AccountUserPermissionsValue = {
  success: boolean | null;
  errorMessage: string;
};

type HookProps = {
  api: vp.Api;
  bearer: string
};

type ReturnTuple = [AccountUserPermissionsValue, (_params: vp.AccountUserPermissionsPostRequest) => void, () => void];

function usePostAccountUserPermissions({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.AccountUserPermissionsPostRequest | null>(null);
  const [response, setResponse] = useState<AccountUserPermissionsValue>({ success: null, errorMessage: '' });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (AccountUserPermissions: vp.AccountUserPermissionsPostRequest) => {
      setDataFetchingInfo(true, 'saving permissions', 'fullScreen');

      const { Success, ErrorMessage } = await api.postAccountUserPermissions(AccountUserPermissions, bearer, source);

      setResponse({ success: Success, errorMessage: ErrorMessage });
      setSendRequest(false);
      setDataFetchingInfo(false);
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.AccountUserPermissionsPostRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setParams(null);
      setResponse({ success: null, errorMessage: '' });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostAccountUserPermissions);
